var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MainLayout",
    { attrs: { "page-name": "registration-symbol-master" } },
    [
      _c(
        "PageHeader",
        { attrs: { title: _vm.title } },
        [
          _c(
            "el-row",
            { staticClass: "header-button" },
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "import",
                      attrs: { type: "primary" },
                      on: { click: _vm.clickImport }
                    },
                    [_vm._v("新規取込")]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "register",
                      attrs: { type: "primary" },
                      on: { click: _vm.clickRegister }
                    },
                    [_vm._v("新規追加")]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "detail-search",
                      attrs: { type: "primary" },
                      on: { click: _vm.clickDetailSearch }
                    },
                    [_vm._v("詳細検索")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "SimpleSearch",
            {
              attrs: { model: _vm.simpleSearchFormModel },
              on: { search: _vm.clickSearch }
            },
            [
              _c("RegistrationSymbol", {
                attrs: {
                  searchCond: true,
                  "autocomplete-list": _vm.registrationSymbolSet
                },
                model: {
                  value: _vm.simpleSearchFormModel.registration_symbol,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.simpleSearchFormModel,
                      "registration_symbol",
                      $$v
                    )
                  },
                  expression: "simpleSearchFormModel.registration_symbol"
                }
              }),
              _c("OwnerCode", {
                attrs: {
                  searchCond: true,
                  "autocomplete-list": _vm.ownerCodeSet
                },
                model: {
                  value: _vm.simpleSearchFormModel.owner_code,
                  callback: function($$v) {
                    _vm.$set(_vm.simpleSearchFormModel, "owner_code", $$v)
                  },
                  expression: "simpleSearchFormModel.owner_code"
                }
              }),
              _c("ModelCode", {
                attrs: {
                  searchCond: true,
                  "autocomplete-list": _vm.modelCodeSet
                },
                model: {
                  value: _vm.simpleSearchFormModel.model_code,
                  callback: function($$v) {
                    _vm.$set(_vm.simpleSearchFormModel, "model_code", $$v)
                  },
                  expression: "simpleSearchFormModel.model_code"
                }
              }),
              _c("AircraftType", {
                attrs: {
                  searchCond: true,
                  initialize: true,
                  placeholder: "機体区分",
                  label: ""
                },
                model: {
                  value: _vm.simpleSearchFormModel.aircraft_type,
                  callback: function($$v) {
                    _vm.$set(_vm.simpleSearchFormModel, "aircraft_type", $$v)
                  },
                  expression: "simpleSearchFormModel.aircraft_type"
                }
              }),
              _c(
                "div",
                { staticClass: "dummy" },
                [_c("AircraftAttribute", { attrs: { initialize: true } })],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Table", {
        attrs: {
          "table-data": _vm.tableData,
          "csv-export": true,
          "csv-file-name": "登録機データ.CSV",
          dataFormatter: _vm.csvDataFormatter,
          "default-sort": { prop: "registration_symbol", order: "ascending" },
          "csv-encoding": "SJIS",
          "table-header-name": _vm.tableHeaderName
        },
        on: { "row-click": _vm.clickRow, "multiple-delete": _vm.deleteRows },
        scopedSlots: _vm._u([
          {
            key: "columns",
            fn: function() {
              return [
                _c("RegistrationSymbolColumn"),
                _c("OwnerCodeColumn"),
                _c("DateTimeColumn", {
                  attrs: { label: "適用開始日時", prop: "start_date" }
                }),
                _c("DateTimeColumn", {
                  attrs: { label: "適用終了日時", prop: "end_date" }
                }),
                _c("ModelCodeColumn"),
                _c("AircraftTypeColumn"),
                _c("WeightColumn", {
                  attrs: { label: "重量1", prop: "weight_1" }
                }),
                _c("NoiseLevelColumn", {
                  attrs: { label: "騒音値1", prop: "noise_level_1" }
                }),
                _c("BlankColumn"),
                _c("MenuColumn", {
                  attrs: { cbdelete: _vm.deleteRow },
                  on: { copy: _vm.copyRow }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("RegistrationSymbolMasterImportDialog", {
        attrs: { visible: _vm.importDialogVisible },
        on: {
          "update:visible": function($event) {
            _vm.importDialogVisible = $event
          },
          refresh: _vm.refreshSearch
        }
      }),
      _c("RegistrationSymbolMasterRegisterDialog", {
        attrs: {
          visible: _vm.registerDialogVisible,
          "autocomplete-registration-symbol-set": _vm.registrationSymbolSet,
          "autocomplete-owner-code-set": _vm.ownerCodeSet,
          "autocomplete-model-code-set": _vm.modelCodeSet,
          "current-row": _vm.currentRow
        },
        on: {
          "update:visible": function($event) {
            _vm.registerDialogVisible = $event
          },
          refresh: _vm.refreshSearch
        }
      }),
      _c("RegistrationSymbolMasterDetailSearchDialog", {
        attrs: {
          visible: _vm.detailDalogVisible,
          "autocomplete-registration-symbol-set": _vm.registrationSymbolSet,
          "autocomplete-owner-code-set": _vm.ownerCodeSet,
          "autocomplete-model-code-set": _vm.modelCodeSet
        },
        on: {
          "update:visible": function($event) {
            _vm.detailDalogVisible = $event
          },
          search: _vm.detailSearch
        }
      }),
      _c("RegistrationSymbolMasterEditDialog", {
        attrs: {
          visible: _vm.editDialogVisible,
          "autocomplete-owner-code-set": _vm.ownerCodeSet,
          "autocomplete-model-code-set": _vm.modelCodeSet,
          "current-row": _vm.currentRow
        },
        on: {
          "update:visible": function($event) {
            _vm.editDialogVisible = $event
          },
          refresh: _vm.refreshSearch
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }